import React from "react";
import InputField from "components/InputField/InputField";
import FileField from "components/InputField/FileField";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControl, FormControlLabel } from "material-ui/Form";

const labels = {
  title: "Title",
  namespace: "Namespace",
  logo: "Logo",
};

const NewSponsorForm = ({
  sponsor = {},
  errors = {},
  onFieldChange,
  onSubmit,
}) => {
  return (
    <div className="container_records">
      <div className="add_webinar new-webinar">
        <h3>Add sponsor</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            {["title", "namespace"].map((e) => (
              <InputField
                className="col s12"
                label={labels[e]}
                field_name={e}
                onChange={onFieldChange}
                errors={errors[e]}
                autoComplete="new-password"
                value={sponsor[e]}
              />
            ))}
            <FileField
              className="col s12"
              field_name="logo"
              onChange={onFieldChange}
              label={labels["logo"]}
              errors={errors["logo"]}
            />

            <FormControl className="wimin-webinar">
              Show Sponsor Title
              <RadioGroup
                aria-label="Show Sponsor Title"
                label="Show Sponsor Title"
                value={sponsor.show_sponsor_title}
                onChange={(e, value) =>
                  onFieldChange({
                    target: {
                      name: "show_sponsor_title",
                      value: value === "true",
                    },
                  })
                }
                row
              >
                <FormControlLabel
                  value={true}
                  control={<Radio color="primary" />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio color="primary" />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>

            <button
              onClick={onSubmit}
              className="button_classic"
              type="button"
              name="button"
            >
              {" "}
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

NewSponsorForm.defaultProps = {};
export default NewSponsorForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Sponsor/NewSponsorForm.jsx